<template>
  <section class="swpoll-congrats">
    <canvas class="swpoll-confetti" id="canvas-confetti"></canvas>

    <div class="swpoll-congrats-head">
      <h5>{{showCongrats ? 'Congratulations!' : 'Completed.'}}</h5>
    </div>

    <div class="swpoll-congrats-body">

      <div class="swpoll-congrats-content" v-if="showCongrats">
        <div class="swpoll-congrats-picto">
          <img src="@/assets/img/completed-quiz.svg" alt="A cup pictogram">
        </div>
        <h5>You completed the quiz!</h5>
        <div class="swpoll-timer-static">
          <p>You completed it in:</p>
          <div class="swpoll-timer-nrs">
            <div class="swpoll-timer-nr">
              <span class="swpoll-timer-nrbg">
                {{ minutes }}
              </span>
              <p>min</p>
            </div>
            <div class="swpoll-timer-nr">
              :
            </div>
            <div class="swpoll-timer-nr">
              <span class="swpoll-timer-nrbg">
                {{ seconds }}
              </span>
              <p>sec</p>
            </div>
          </div>
          <p v-if="!loading">and you had <strong>{{ getCorrectAnswersCount }}/{{ getTotalAnswersCount }}</strong> correct answers</p>
        </div>
        <div class="swpoll-congrats-conclusion">
          <p v-if="!loading && scoring !== 'none'">This qualifies you for the <strong>{{ getQuizPosition }}</strong> out of {{ getQuizParticipants }} participants on the current quiz, and <strong>{{ getTotalPosition }}</strong> out of {{ getTotlParticipants }} participants all time.</p>
        </div>
        <div class="swpoll-congrats-cta">
          <button class="btn btn-outline btn-block btn-showsummary"
            v-if="groupResults"
            @click="switchView('summary')"
          >
            See Answers Summary
          </button>
          <br/>
          <button class="btn btn-primary btn-block btn-showleaderboard"
            v-if="leaderboardEnabled"
            @click="switchView('leaderboard')"
          >
            Go To Leaderboard
          </button>
        </div>
      </div>
      <div class="swpoll-congrats-content" v-if="!showCongrats">
        <h5>Thank you</h5>
      </div>
    </div>
    <div class="swpoll-congrats-foot">
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import {
  mapActions,
  mapState,
  mapGetters
} from 'vuex';
import VueConfetti from 'vue-confetti'
import { runInThisContext } from 'vm';

Vue.use(VueConfetti);

export default {
  name: 'Congratulations',
  data() {
    return {
      loading: true,
      minutes: 0,
      seconds: 0
    }
  },
  computed: {
    ...mapState('poll', [
      'group',
      'accountName',
      'pollGroupId'
    ]),
    ...mapState('voter', [
      'points',
      'rank',
      'voterId',
      'name',
      'countIncorrectAnswers',
      'countTotalAnswers',
    ]),
    ...mapGetters('voter', [
      'getTotalAnswersCount',
      'getQuizPosition',
      'getQuizParticipants',
      'getTotalPosition',
      'getTotlParticipants',
      'getCorrectAnswersCount'
    ]),
    ...mapState('pollGroup', [
      'groupResults',
      'showCongrats',
      'leaderboardEnabled',
      'scoring'
    ]),
    ...mapState('poll', {
      pollGroupIdFromPollStore: state => state.pollGroupId
    }),
    ...mapState('pollGroup', {
      pollGroupIdFromPollGroupStore: state => state.pollGroupId
    })
  },
  methods: {
    ...mapActions('voter', [
      'switchView',
      'loadVoterSummary',
      'getLeaderBoardByPollGroup',
    ])
  },
  async mounted() {
    const canvas = document.getElementById("canvas-confetti");
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const pollGroupId = this.pollGroupIdFromPollStore || this.pollGroupIdFromPollGroupStore;

    await this.loadVoterSummary(pollGroupId);
    const topScoresList = await this.getLeaderBoardByPollGroup({ pollGroupId });
    const voterData = topScoresList.find(obj => {
      return obj.voterId === this.voterId;
    });
    if (voterData) {
      this.minutes = Math.floor(voterData.time / 60);
      this.seconds = voterData.time % 60;
    }
    this.loading = false;

    if (this.showCongrats) {
      this.$confetti.start({
        canvasId: 'canvas-confetti',
        particles: [
          {
            type: 'rect'
          }
        ]
      });
      setTimeout(() => {
        this.$confetti.stop()
      }, 3000);
    }

  }
}
</script>

<style scoped lang="scss">
section {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background-color: var(--background-color);
  z-index: 2;
  text-align: center;
  padding: 30px;
}

h5 {
  font-size: 1.4rem;
  margin: 0;
}

.swpoll-confetti {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.swpoll-congrats {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background-color: var(--background-color);
  z-index: 2;
  text-align: center;
  padding: 30px;
  // opacity: 0;
  // visibility: hidden;
  // -webkit-transition: opacity .6s, visibility .6s;
  // transition: opacity .6s, visibility .6s;
}

@media only screen and (min-width: 600px) {
  .swpoll-congrats {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    padding: 32px 0;
  }
}

.swpoll-congrats-head, .swpoll-congrats-body, .swpoll-congrats-foot {
  // -webkit-transition: 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  // transition: 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  // -webkit-transform: translateY(70px);
  //         transform: translateY(70px);
  // opacity: 0;
}

.swpoll-congrats-body {
  padding-top: 24px;
  padding-bottom: 8px;
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

@media only screen and (min-width: 600px) {
  .swpoll-congrats-body {
    -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
            flex: 0 0 auto;
    width: 100%;
    max-width: 350px;
    padding-top: 48px;
  }
}

.swpoll-congrats-conclusion {
  margin-top: 24px;
  width: 350px;
}

@media only screen and (min-width: 600px) {
  .swpoll-congrats-conclusion {
    padding-bottom: 16px;
  }
}

.swpoll-congrats-foot {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 100%;
}

@media only screen and (min-width: 600px) {
  .swpoll-congrats-foot {
    max-width: 350px;
  }
}

.swpoll-timer-static {
  margin: 24px 0;
}

.swpoll-timer-static p {
  margin: 0;
}

.swpoll-timer-nrs {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-column-gap: 4px;
          column-gap: 4px;
  margin: 8px 0;
}

.swpoll-timer-nr {
  font-size: 2rem;
}

.swpoll-timer-nr p {
  margin: 0;
  font-size: 1rem;
}

.swpoll-timer-nrbg {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 4px 10px;
  margin-bottom: 4px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.btn {
  display: inline-block;
  line-height: 1em;
  padding: 16px 20px;
  text-align: center;
  border: none;
  border-radius: var(--button-radius);
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
}

.btn:hover {
  cursor: pointer;
}

.btn:focus {
  outline: none;
}

.btn.disabled {
  -webkit-box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
          box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
  pointer-events: none;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.5);
}

.btn-outline {
  background-color: transparent;
  color: var(--button-color);
  -webkit-box-shadow: 0 0 0 2px inset var(--button-color);
          box-shadow: 0 0 0 2px inset var(--button-color);
}

.btn-outline:hover {
  -webkit-box-shadow: 0 0 0 3px inset var(--button-color);
          box-shadow: 0 0 0 3px inset var(--button-color);
}

.btn-primary {
  background-color: var(--button-bg);
  color: var(--button-color);
  -webkit-transition: .25s ease-out;
  transition: .25s ease-out;
}

.btn-primary:hover, .btn-primary:active {
  background-color: var(--button-bg-hover);
  -webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
          box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-small {
  padding-top: 10px;
  padding-bottom: 10px;
}

</style>
